import ErrorBoundary from './error_boundary'
import FooterNav from './footernav'
import HeaderNav from './headernav'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import React, {Component} from 'react'
import ServerContext from './serverContext'
import {TrackingProvider, ViewContext} from './tracking'
import {breakpoints} from '../styles'
import {connect} from 'react-redux'
import {css} from 'glamor'
import {setMediaBreakpoint} from '../redux/actions/media'
import EmailModal from './emailModal/index'
import {Attentive} from '../bundle/client/components/attentive/attentive'
import {datadogRum} from '@datadog/browser-rum'

let xsMediaQueryList
let smMediaQueryList
let mdMediaQueryList
let lgMediaQueryList

const style = {
  container: css({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh'
  }),
  content: css({
    flex: '1 auto'
  })
}

class Main extends Component {
  static initialize(props) {
    return HeaderNav.initialize(props)
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    xsMediaQueryList = window.matchMedia(breakpoints.xs)
    smMediaQueryList = window.matchMedia(breakpoints.sm)
    mdMediaQueryList = window.matchMedia(breakpoints.md)
    lgMediaQueryList = window.matchMedia(breakpoints.lg)

    xsMediaQueryList.addListener(this.setWindowXs)
    smMediaQueryList.addListener(this.setWindowSm)
    mdMediaQueryList.addListener(this.setWindowMd)
    lgMediaQueryList.addListener(this.setWindowLg)

    if (xsMediaQueryList.matches) {
      this.props.dispatch(setMediaBreakpoint('xs'))
    } else if (smMediaQueryList.matches) {
      this.props.dispatch(setMediaBreakpoint('sm'))
    } else if (mdMediaQueryList.matches) {
      this.props.dispatch(setMediaBreakpoint('md'))
    } else if (lgMediaQueryList.matches) {
      this.props.dispatch(setMediaBreakpoint('lg'))
    }

    // Initialize DataDog Real User Monitoring (RUM)
    datadogRum.init({
      applicationId: this.props.dataDogConfig.applicationId,
      clientToken: this.props.dataDogConfig.clientToken,
      site: 'datadoghq.com',
      service: this.props.dataDogConfig.service,
      env: this.props.env,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: '1.0.0',
      sampleRate: this.props.dataDogConfig.rate,
      trackInteractions: this.props.dataDogConfig.trackInteractions
    })
  }

  componentWillUnmount() {
    xsMediaQueryList.removeListener(this.setWindowXs)
    smMediaQueryList.removeListener(this.setWindowSm)
    mdMediaQueryList.removeListener(this.setWindowMd)
    lgMediaQueryList.removeListener(this.setWindowLg)
  }

  setWindow = (event, size) => {
    if (event.matches) {
      this.props.dispatch(setMediaBreakpoint(size))
    }
  }

  setWindowXs = event => this.setWindow(event, 'xs')
  setWindowSm = event => this.setWindow(event, 'sm')
  setWindowMd = event => this.setWindow(event, 'md')
  setWindowLg = event => this.setWindow(event, 'lg')

  render() {
    const {
      children,
      env,
      globals,
      hosts,
      location,
      tracking,
      googleSiteVerificationToken
    } = this.props
    const {
      meta: {title, description}
    } = globals
    const admin = /^\/admin\//.test(location.pathname)

    // Extract component name
    const {displayName} = children.type.WrappedComponent || children.type

    return (
      <ServerContext.Provider value={{env, hosts}}>
        <TrackingProvider {...tracking}>
          <div {...style.container}>
            <Helmet>
              <title>{title}</title>
              <meta name="description" content={description} />
              {googleSiteVerificationToken && (
                <meta
                  name="google-site-verification"
                  content={googleSiteVerificationToken}
                />
              )}
            </Helmet>
            <noscript suppressHydrationWarning>
              <div className="container">
                <div className="noscript">
                  <p>JavaScript is currently turned off.</p>
                  <p>
                    Turn it on in <em>Settings</em> to view this website.
                  </p>
                </div>
              </div>
            </noscript>
            {!admin && <HeaderNav location={location} />}
            <ErrorBoundary {...style.content}>
              <ViewContext.Provider value={displayName}>
                {children}
              </ViewContext.Provider>
            </ErrorBoundary>
            {!admin && <FooterNav location={location} />}
            <EmailModal />
            <Attentive />
          </div>
        </TrackingProvider>
      </ServerContext.Provider>
    )
  }
}

Main.propTypes = {
  children: PropTypes.element,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  env: PropTypes.string,
  globals: PropTypes.object.isRequired,
  hosts: PropTypes.object.isRequired,
  tracking: PropTypes.object.isRequired,
  googleSiteVerificationToken: PropTypes.string,
  dataDogConfig: PropTypes.object.isRequired
}

export default connect(({env, globals, hosts, tracking, tokens, dataDog}) => ({
  env,
  globals,
  hosts,
  tracking,
  googleSiteVerificationToken: tokens
    ? tokens.GOOGLE_SITE_VERIFICATION_TOKEN
    : undefined,
  dataDogConfig: dataDog
}))(Main)
